export default __webpack_public_path__ + "static/media/task-management.6a020d74.svg";